
import api from '@/api';
import _ from 'lodash';

const namespaced = true;

const state = {
  currentUserNotificationRules: [],
};

const mutations = {
  SET_CURRENT_USER_NOTIFICATION_RULES(state, notificationRules) {
    state.currentUserNotificationRules = notificationRules;
  },
  ADD_NOTIFICATION_RULE(state, notificationRule) {
    state.currentUserNotificationRules.push(notificationRule);
  },
  REMOVE_NOTIFICATION_RULE(state, notificationRuleId) {
    state.currentUserNotificationRules = _.reject(state.currentUserNotificationRules, { id: notificationRuleId });
  },
};

const actions = {
  async fetchCurrentUserNotificationRules({ commit, rootState }) {
    const { data: notificationRules } = await api.get(`/notification-rules/user/${rootState[`model/user`].currentUser.id}`);
    commit(`SET_CURRENT_USER_NOTIFICATION_RULES`, notificationRules);
  },
  async addNotificationRule({ commit }, notificationRule) {
    const { data: newNotificationRule } = await api.post(`/notification-rules`, notificationRule);
    commit(`ADD_NOTIFICATION_RULE`, newNotificationRule);
    return newNotificationRule;
  },
  async removeNotificationRule({ commit }, id) {
    await api.delete(`/notification-rules/${id}`);
    commit(`REMOVE_NOTIFICATION_RULE`, id);
  },
};

const getters = {
  getMaker: state => id => _.find(state.makers, maker => _.toInteger(maker.id) === _.toInteger(id)) || null,
  writeMakers(state) {
    return _.filter(state.makers, maker =>
      maker.right.id === 3
    );
  },
};

export default {
  namespaced, state, mutations, actions, getters,
};
